import {FC} from 'react'
import {PaymentOption} from '../../../core/_models'

type Props = {
  paymentOption: PaymentOption
}

const FranchiseCell: FC<Props> = ({paymentOption}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        {paymentOption.franchise?.name ?? <span className='badge badge-light-primary'>Global</span>}
      </div>
    </div>
  )
}

export {FranchiseCell}
